import {AccountFieldsFragment, useRestrictedKeywordsQuery} from 'api/generated';
import {unique} from '../lib/utils';
import {useAccessLevel} from './useAccessLevel';

export const useIgnoredKeywords = (account: AccountFieldsFragment) => {
  const {isAdmin} = useAccessLevel();

  const {data} = useRestrictedKeywordsQuery({
    skip: !isAdmin
  });

  const riskLabels = account?.riskLabels?.slice() || [];
  const restrictedKeywords = unique(data?.restrictedKeywords || []);

  // Extract restricted keywords from risk labels
  const label = riskLabels.find((label) => label.category === 'websiteContent');

  // Default options for restricted keywords
  const defaultKeywordsOptions = {
    label: 'All keywords',
    title: 'all',
    options: restrictedKeywords.map((keyword, index) => ({
      label: keyword,
      value: keyword,
      key: `option-default-${index}` // Assigning unique key for each option
    }))
  };

  if (!label) {
    return {
      restrictedKeywords,
      parsedRestrictedKeywords: [],
      keywordsOptions: [defaultKeywordsOptions]
    };
  }

  const parsedRestrictedKeywords = unique(
    label
      .label!.match(/restricted keywords: (.*)/)?.[1]
      .split(', ')
      .map((item) => item.trim()) || []
  );

  // Parsed options for restricted keywords
  const parsedKeywordsOptions = {
    label: 'Found keywords',
    title: 'found',
    options: parsedRestrictedKeywords.map((keyword, index) => ({
      label: keyword,
      value: keyword,
      key: `option-parsed-${index}` // Assigning unique key for each option
    }))
  };

  // Return separate lists of restricted keywords and parsed keywords
  return {
    restrictedKeywords,
    parsedRestrictedKeywords: unique(parsedRestrictedKeywords),
    keywordsOptions: [parsedKeywordsOptions, defaultKeywordsOptions]
  };
};
